import type { Route } from "@angular/router";

import { ImpersonateComponent } from "./impersonate.component";
import { LoginComponent } from "./login.component";
import { OAuthCallbackComponent } from "./oauth-callback.component";
import { VerifyTwoFactorComponent } from "./verify-two-factor.component";

export const loginRoute: Route = {
    path: "login",
    component: LoginComponent,
    data: {
        breadcrumb: "Login",
        hidenav: true,
    },
};
export const verifyTwoFactorRoute: Route = {
    path: "login/verify",
    component: VerifyTwoFactorComponent,
    data: {
        breadcrumb: "Verification Code",
        hidenav: true,
    },
};
export const loginViaImpersonateRoute: Route = {
    path: "impersonate",
    component: ImpersonateComponent,
    data: {
        breadcrumb: "Impersonate",
        hidenav: true,
    },
};
export const oauthCallbackRoute: Route = {
    path: "login/oauth-callback",
    component: OAuthCallbackComponent,
    data: {
        breadcrumb: "OAuth",
        hidenav: true,
    },
};
